import { Component } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { DialogRentalAgencyComponent } from '@pages/tables/rental-agency/dialog-rental-agency/dialog-rental-agency.component';
import { RentalAgencyModel } from '@/models/tables/rental-agency.model';

@Component({
  selector: 'app-button-new-rental-agency',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonNewRentalAgencyComponent extends ButtonComponent {
  private dialogOpened: MatDialogRef<any>;
  faIcon = faPenToSquare;

  constructor(
    protected router: Router,
    protected toastr: ToastrService,
    private dialog: MatDialog,
  ) {
    super(router, toastr);

    this.showIcon = false;
    this.additionalClass = 'ml-2';
    this.content = 'Nuova Agenzia Noleggio';
  }

  /**
   * Open modal new detail page
   */
  public actionClick(): void {
    this.dialogOpened = this.dialog.open(DialogRentalAgencyComponent, {
      data: new RentalAgencyModel(),
    });

    Registry.getInstance().set('DialogRentalAgencyComponentNew', this.dialogOpened);
  }
}
